// Showcase Container Component
// Container that renders all showcase categories

import { SHOWCASE_CATEGORIES } from "./showcase-config.ts";
import type { ShowcaseCategoryComponent } from "./showcase-category.ts";

class ShowcaseContainer extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private render() {
    // Create category elements for each category in the config
    const categoriesHtml = SHOWCASE_CATEGORIES.map((category) => {
      return `<showcase-category category-id="${category.id}"></showcase-category>`;
    }).join("\n");

    this.innerHTML = categoriesHtml;

    // Set config for each category after rendering
    setTimeout(() => {
      const categories = this.querySelectorAll("showcase-category");
      categories.forEach((category, index) => {
        (category as ShowcaseCategoryComponent).setConfig(SHOWCASE_CATEGORIES[index]);
      });

      // Re-apply language after all categories are rendered
      if (globalThis.switchLang) {
        const currentLang = localStorage.getItem("dammi_lang") || "en";
        globalThis.switchLang(currentLang);
      }
    }, 0);
  }
}

customElements.define("showcase-container", ShowcaseContainer);

export { ShowcaseContainer };

